<template>
  <div class="role-auth-document">
    <div class="role-auth-aside">
      <div class="role-auth_bar">
        <el-select v-model="folderArea" size="small" style="width: 85%;margin-bottom:12px" filterable
          @change="typeChange">
          <el-option v-for="(item, id) in folderAreaList" :key="id" :value="item.id" :label="item.name">
          </el-option>
        </el-select>
        <i class="el-icon-synchro" title="同步" @click="openSynchro"></i>
        <span v-if="folderArea=='3'" style="display: block;margin-bottom: 3px;">请选择目录
          <el-tooltip effect="light" content="目录数据来自系统-目录模版下的成品区一级目录">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </span>
        <select-tree v-if="folderArea=='3'" ref="selectTree" style="width:100%;margin-bottom:12px" :props="catalogueTypeTreeProps" :options="finishedProductArea"
          :value="catalogueType" :clearable="false" :accordion="true" size="small" @getValue="getValue($event)">
        </select-tree>

        <el-input v-model="filterText" placeholder="输入关键字进行过滤" size="small" clearable>
          <template #prefix>
            <i class="el-icon-search el-input__icon" />
          </template>
        </el-input>
      </div>
      <el-tree ref="roletree" :data="roleducmentList" :props="defaultRoleProps" :filter-node-method="filterNode"
        :expand-on-click-node="false" node-key="nodeId" highlight-current default-expand-all class="role-auth-tree"
        :style="{'top':folderArea=='3'?'170px':'110px'}" @node-click="systemTableClick">
        <template #default="{ data }">
          <div class="tree-content">
            <div style="display:flex;align-items:center;color:font-weight:400">
              <img :src="iconFn(data)" style="margin-right: 6px" alt="" />
              <span :title="data.roleName" class="textAll">{{
                data.roleName
              }}</span>
            </div>
          </div>
        </template>
      </el-tree>
    </div>
    <div v-if="roleducmentList.length>0" class="role-auth-content">
      <div class="role-auth-title">
        <span>角色权限</span>
        <div class="buttons">
          <div v-if="checkboxShow">
            <el-checkbox v-model="checked">{{ checkTitle }}</el-checkbox>
          </div>
          <el-button type="text" icon="el-icon-refresh-right" @click="batchRefreshEnterpriseSpecPrivi">
            修正缺失的权限
          </el-button>
          <div v-if="!systemAddOption.$isOperation" class="buttons">
            <el-button v-preventReClick size="small" type="primary" class="role-right-button" :disabled="isDisabled||isClick" @click="submit">
              保存
            </el-button>
            <el-button v-if="folderArea == '3'" v-preventReClick size="small" class="role-right-button" @click="emptyFinishedArea">
              清空成品区子级目录权限
            </el-button>
            <el-button
              v-if="synchronizationSpecShow"
              size="small"
              class="role-right-button"
              :disabled="!isDisabled||isInitialPM"
              style="margin-right:8px"
              @click="synchronization">
              同步到其他专业
            </el-button>
            <el-button
              v-if="synchronizationRoleShow"
              size="small"
              class="role-right-button"
              :disabled="!isDisabled"
              style="margin-right:8px"
              @click="synchronization">
              同步到其他角色
            </el-button>
          </div>
        </div>
      </div>
      <div class="role-right-bottom">
        <template>
          <div style="display: flex;justify-content: space-between;">
            <div v-if="!systemAddOption.$isOperation && systemAddOption.roleID == 'Sp_001'" class="role-rigth-title">
              请设置{{ systemAddOption.roleName }}对本专业内文件夹的权限
            </div>
            <div v-else-if="!systemAddOption.$isOperation && systemAddOption.roleID == 'Sp_003'" class="role-rigth-title">
              请设置项目管理对本专业的文件夹权限
            </div>
            <div v-else-if="!systemAddOption.$isOperation&& folderArea !== '3'" class="role-rigth-title">
              请设置{{ systemAddOption.roleName }}对其他专业的文件夹权限
            </div>
            <div v-if="!systemAddOption.$isOperation && folderArea == '3'" class="role-rigth-title">
              请设置角色对{{ catalogueTypeName }}文件夹的权限
            </div>
          </div>
        </template>
        <template>
          <div v-if="systemAddOption.$isOperation && folderArea == '1'" class="empty mt-40">
            请选择左侧角色或者专业内、专业间、项目管理
          </div>
          <div v-if="systemAddOption.$isOperation && folderArea == '2'" class="empty mt-40">
            请选择左侧角色或者专业内、专业间
          </div>
          <div v-else-if="systemAddOption.$isOperation && folderArea == '3'" class="empty mt-40">
            请选择左侧角色或者专业
          </div>
          <div v-if="!systemAddOption.$isOperation" class="role-right-table">
            <rolePermisson :table-data="tableData" :role-type="folderArea" :checked="checked"></rolePermisson>
          </div>
        </template>
      </div>
    </div>
    <el-dialog v-dialogDrag :visible.sync="prjDialog" :before-close="prjClose" :close-on-click-modal="false"
      :close-on-press-escape="false" title="同步至已有项目" width="695px" class="prjDialog">
      <el-form ref="prjForm" :model="prjForm" label-position="right" style="display: flex;margin-bottom:5px" size="small">
        <el-form-item label="" style="display: flex;margin-right:20px;margin-bottom:0px">
          <el-input v-model="prjForm.prjName" placeholder="请输入项目名称" size="small" prefix-icon="el-icon-search" clearable
            @input="fetchData(1)"></el-input>
        </el-form-item>
        <el-form-item label="" style="display: flex;margin-bottom:0px">
          <el-input v-model="prjForm.prjCode" placeholder="请输入项目编号" size="small" prefix-icon="el-icon-search" clearable
            @input="fetchData(1)"></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-table ref="multipleTable" :data="prjtableData" tooltip-effect="dark" style="width: 100%" height="570"
          border @select-all="selectall" @select="selectchange">
          <el-table-column type="selection" align="center" width="55">
          </el-table-column>
          <el-table-column label="项目名称" show-overflow-tooltip prop="prjName" align="center">
          </el-table-column>
          <el-table-column label="项目编号" show-overflow-tooltip prop="prjCode" align="center">
          </el-table-column>
          <el-table-column label="项目总负责人" show-overflow-tooltip prop="prjLeaderName" align="center">
          </el-table-column>
        </el-table>
      </div>
      <div class="page">
        <el-pagination v-if="page.totalCount>0" :current-page.sync="page.pageNo" :page-size="page.pageSize"
          :layout="page.pageLayout" :total="page.totalCount" :page-sizes="[10, 20, 50, 100]" size="small" background
          @current-change="fetchData" @size-change="handleSizeChange" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="prjClose">取 消</el-button>
        <div v-loading="loading" style="display:inline-block;margin-left:10px">
          <el-button v-preventReClick type="primary" plain size="small" @click="getPrjContain(1)">同步至所有</el-button>
          <el-button v-preventReClick type="primary" plain size="small" @click="getPrjContain(0)">同步至所选</el-button>
        </div>
      </span>
    </el-dialog>
    <sync-major-role-dlg
      ref="syncMajorRoleDlg"
      :parentRoleID="parentRoleID"
      :folderArea="folderArea"
      :roleID="systemAddOption.roleID"
      :templateSpecId="templateSpecId"
      :catalogueType="catalogueType"
      @getFinishedProductArea="getFinishedProductArea"
    ></sync-major-role-dlg>
  </div>
</template>
<script>
import roleService from "@/CommonDP/service/admin/role-service";
import rolePermisson from "@/CommonDP/components/rolePermisson";
import docPriviService from "@/CommonDP/service/docPrivi-service";
import createProjectService from "@/CommonDP/service/createProject-service";
import { mapState } from "vuex";
import syncMajorRoleDlg from '@/CommonDP/pages/mainMg/settings/permission/components/syncMajorRoleDlg.vue';
import SelectTree from "@/CommonDP/components/selectTree";

const DEFAULT_FOLDER_AREAS = [
  { id: "1", name: "设计区" },
  { id: "2", name: "提资区" },
  { id: "3", name: "成品区" }
];
const systemAddOptionParams = () => ({
  roleID: "",
  $isOperation: "",
  roleName: "",
  pid: ""
});
export default {
  components: { rolePermisson, syncMajorRoleDlg, SelectTree },
  data() {
    return {
      filterText: "",
      roleducmentList: [],
      defaultRoleProps: {
        children: "childList",
        label: "roleName"
      },
      major_png: require("@/CommonDP/assets/settings/major.png"),
      role_png: require("@/CommonDP/assets/settings/systemRole.png"),
      spec_png: require("@/CommonDP/assets/settings/spec.png"),
      pm_png: require("@/CommonDP/assets/settings/pm.png"),
      customRole_png: require("@/CommonDP/assets/settings/customRole.png"),
      systemAddOption: systemAddOptionParams(),
      folderAreaList: DEFAULT_FOLDER_AREAS,
      tableData: [],
      initRoleList: [],
      prjDialog: false,
      prjList: [],
      prjForm: {
        prjCode: "",
        prjName: ""
      },
      prjtableData: [],
      page: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 0,
        pageLayout: "total, sizes,prev, pager, next,jumper" // 分页组件
      },
      pageSelect: [], // 勾选的数据
      queryOldData: [],
      loading: false,
      typeCode: '',
      isOperation: '',
      roleID: '',
      roleName: '',
      parentRoleID: '',
      checked: false,
      nodeData: {},
      finishedProductArea: [],
      catalogueType: '',
      catalogueTypeName: '',
      templateSpecId: '',
      catalogueTypeTreeProps: {
        value: "id",
        label: "cnName",
        children: "childList" // 子级
      },
      isClick: false
    };
  },
  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      enterpriseId: state => state.enterprise.enterpriseId
    }),
    folderArea: {
      get() {
        if (this.typeCode && this.typeCode.length === 1) {
          return this.typeCode;
        } else {
          return "1";
        }
      },
      set() {}
    },
    // 判断是否与原数据发生变化
    isDisabled() {
      return JSON.stringify(this.initRoleList) === JSON.stringify(this.tableData);
    },
    checkTitle() {
      return this.checked ? '取消批量' : '批量选择';
    },
    isInitialPM() {
      return this.tableData[0]?.fileDel == null;
    },
    checkboxShow() {
      return (this.folderArea !== '3' && !this.systemAddOption.$isOperation) || (this.folderArea === '3' && !this.systemAddOption.$isOperation && this.templateSpecId);
    },
    synchronizationSpecShow() {
      return this.systemAddOption.roleID === 'Sp_001' || this.systemAddOption.roleID === 'Sp_002' || this.systemAddOption.roleID === 'Sp_003' || this.templateSpecId;
    },
    synchronizationRoleShow() {
      return this.systemAddOption.roleID !== 'Sp_001' && this.systemAddOption.roleID !== 'Sp_002' && this.systemAddOption.roleID !== 'Sp_003' && !this.templateSpecId;
    }

  },
  watch: {
    filterText(val) {
      this.$refs.roletree.filter(val);
    }
  },
  async created() {
    await this.queryFolderAreaList();
    await this.getTreeList();
    this.getFinishedProductArea();
  },
  methods: {
    async queryFolderAreaList() {
      const res = await docPriviService.queryFolderAreaList();
      if (res.data && res.data.length > 0) {
        this.folderAreaList = res.data;
      }
    },
    filterNode(value, data, node) {
      if (!value) return true;
      if (data.roleName.indexOf(value) !== -1) {
        return true;
      }
      const level = node.level;
      if (level === 1) {
        return false;
      }
      let parentData = node.parent;
      let index = 0;
      while (index < level - 1) {
        if (parentData.data.roleName.indexOf(value) !== -1) {
          return true;
        }
        parentData = parentData.parent;
        index++;
      }
      return false;
    },
    async typeChange(key) {
      console.log(key, "key");
      this.typeCode = key;
      this.isOperation = '';
      this.roleID = '';
      this.roleName = '';
      this.catalogueType = this.finishedProductArea[0].folderId;
      this.catalogueTypeName = this.finishedProductArea[0].folderName;
      setTimeout(() => {
        this.$nextTick(async () => {
          this.roleducmentList = [];
          await this.getTreeList();
        });
      }, 500);
    },
    async getTreeList() {
      var isOperation = this.isOperation;
      var roleID = this.roleID;
      var roleName = this.roleName;
      const typeArea = parseInt(this.folderArea);
      const res = this.folderArea !== '3' ? await roleService.querySysDocPermissionRoleList(this.enterpriseId, typeArea) : await roleService.getProductAreaTreeList(this.enterpriseId, typeArea);
      this.roleducmentList = res.data.map(item => {
        item.$roleID = item.roleID;
        item.roleID = item.id;
        if (item.childList && item.childList.length > 0) {
          item.$isOperation = "1";
        }
        item.pid = "0";
        return item;
      });
      const each = list => {
        for (const item of list) {
          item.nodeId = item.roleID;
          if (item.roleID === 'Sp_001' || item.roleID === 'Sp_002' || item.roleID === 'Sp_003') {
            item.nodeId = item.pid + item.roleID;
          }
          if (item.childList && item.childList.length > 0) each(item.childList);
          else delete item.childList;
        }
      };
      each(this.roleducmentList);
      if (roleID) {
        this.$nextTick(() => {
          if (this.$refs.roletree) this.$refs.roletree.setCurrentKey(roleID);
        });
        if (isOperation === "1") {
          this.systemAddOption.$isOperation = isOperation;
        }
        this.getDocumentList(this.systemAddOption.roleID, isOperation);
        this.systemAddOption.roleName = roleName;
      } else {
        if (this.roleducmentList && this.roleducmentList.length > 0) {
          this.$nextTick(() => {
            if (this.$refs.roletree) {
              this.$refs.roletree.setCurrentKey(this.roleducmentList[0].roleID);
            }
          });
          this.systemAddOption.$isOperation = this.roleducmentList[0].$isOperation;
          this.systemAddOption.roleName = this.roleducmentList[0].roleName;
          this.getDocumentList(this.roleducmentList[0].roleID, this.roleducmentList[0].$isOperation);
          this.typeCode = this.folderArea;
          this.roleID = this.roleducmentList[0].nodeId;
          this.roleName = this.roleducmentList[0].roleName;
          if (this.roleducmentList[0].$isOperation) {
            this.isOperation = "1";
          } else {
            this.isOperation = "0";
          }
        }
      }
    },
    // 点击树
    systemTableClick(row, node) {
      this.systemAddOption = systemAddOptionParams();
      this.templateSpecId = row.templateSpecId;
      this.nodeData = node;
      this.checked = false;
      this.tableData = [];
      this.parentRoleID = this.folderArea !== '3' ? node.parent.data.roleID : row.roleID;
      const roleName = this.folderArea !== '3' && (row.roleID === 'Sp_001' || row.roleID === 'Sp_002' || row.roleID === 'Sp_003') ? node.parent.data.roleName : row.roleName;
      this.getDocumentList(row.roleID, row.$isOperation);
      this.systemAddOption.$isOperation = row.$isOperation;
      this.systemAddOption.roleName = roleName;
      this.systemAddOption.roleID = row.roleID;
      this.typeCode = this.folderArea;
      this.roleID = row.nodeId;
      this.roleName = roleName;
      if (row.$isOperation) {
        this.isOperation = "1";
      } else {
        this.isOperation = "0";
      }
    },
    // 获取对应的权限
    async getDocumentList(roleID, $isOperation) {
      if (!$isOperation || $isOperation === "0") {
        let res = null;
        if (this.folderArea !== '3') {
          const params = {
            enterpriseId: this.enterpriseId,
            specId: this.parentRoleID,
            folderArea: parseInt(this.folderArea),
            specType: roleID
          };
          res = await docPriviService.queryEnterpriseSpecFolderPermissionList(params);
        } else {
          const params = {
            enterpriseId: this.enterpriseId,
            folderId: this.catalogueType,
            templateSpecId: this.templateSpecId,
            roleId: roleID
          };
          res = await docPriviService.queryProductAreaRolePermissionList(params);
        }
        this.tableData = res.data.map(item => {
          item.name = item.roleName;
          if (item.isRead === 2) {
            item.$show = 1;
            item.$down = 1;
          } else if (item.isRead === 1) {
            item.$show = 1;
            item.$down = 0;
          } else {
            item.$show = 0;
            item.$down = 0;
          }
          if (
            item.isRead === 2 &&
            item.fileNew === 1 &&
            item.folderNew === 1 &&
            item.fileDel === 1 &&
            item.isSubmit === 1 &&
            item.isPlaceFile === 1 &&
            item.isPrint === 1 &&
            item.isPriviSet === 1 &&
            item.priviAll === 1 &&
            item.isSnapshot === 1 &&
            this.folderArea === "1"
          ) {
            item.$selectAll = 1;
          } else if (
            item.$show === 1 &&
            item.$down === 1 &&
            item.folderNew === 1 &&
            item.fileDel === 1 &&
            item.isPriviSet === 1 &&
            item.priviAll === 1 &&
            item.isSnapshot === 1 &&
            this.folderArea === "2"
          ) {
            item.$selectAll = 1;
          } else if (
            item.$show === 1 &&
            item.$down === 1 &&
            item.fileNew === 1 &&
            item.folderNew === 1 &&
            item.fileDel === 1 &&
            item.isPrint === 1 &&
            item.isPriviSet === 1 &&
            item.priviAll === 1 &&
            item.isSnapshot === 1 &&
            this.folderArea === "3"
          ) {
            item.$selectAll = 1;
          } else {
            item.$selectAll = 0;
          }
          return item;
        });
        this.initRoleList = JSON.parse(JSON.stringify(this.tableData));
        this.isClick = false;
      }
    },

    async submit() {
      this.isClick = true;
      const { tableData } = this;
      const array = tableData.map(item => {
        if (item.$show === 1 && item.$down === 1) item.isRead = 2;
        else if (item.$show === 1 && item.$down === 0) item.isRead = 1;
        else item.isRead = 0;
        return item;
      });
      try {
        const res = await docPriviService.updateListForCheckedRole(array);
        if (res.result === "0") this.$message.success("提交成功");
        await this.getTreeList();
        if (this.folderArea === '3') {
          this.getFinishedProductArea();
        }
      } catch {
        this.isClick = false;
      }
    },

    async batchRefreshEnterpriseSpecPrivi() {
      await this.$confirm("此操作可能耗时较长，且无法撤回，确认继续操作吗？");
      await docPriviService.batchRefreshEnterpriseSpecPrivi(this.enterpriseId);
    },
    prjClose() {
      this.prjDialog = false;
    },
    async openSynchro() {
      this.pageSelect = [];
      this.prjtableData = [];
      this.prjForm.prjCode = "";
      this.prjForm.prjName = "";
      this.prjDialog = true;
      this.queryPrjtableData();
      this.loading = false;
    },
    async getPrjContain(val) {
      const prjIds = this.pageSelect.map(item => item.prjId);
      const params = {
        enterpriseId: this.enterpriseId,
        prjIds: prjIds,
        syncType: val,
        folderArea: parseInt(this.folderArea)
      };
      if (val === 1 && !this.prjtableData.length) {
        this.$message({ message: "暂无项目", type: "warning" });
        return;
      }
      if (val === 0 && !this.pageSelect.length) {
        this.$message({ message: "请选择项目", type: "warning" });
        return;
      }
      this.loading = true;
      try {
        await docPriviService.permissionSyncProject(params);
        this.$message.success("同步成功");
        this.loading = false;
        this.prjDialog = false;
      } catch {
        this.loading = false;
      }
    },
    async queryPrjtableData() {
      this.$nextTick(() => {
        this.$refs.multipleTable.clearSelection();
      });
      const {
        page: { pageNo, pageSize },
        enterpriseId
      } = this;
      const params = {
        enterpriseId,
        pageNum: pageNo,
        pageSize,
        ...this.prjForm
      };
      const res = await createProjectService.getPrjData(params);
      this.prjtableData = res.data;
      this.page.totalCount = res.totalCount;
      var data222 = [];
      for (var s = 0; s < this.pageSelect.length; s++) {
        for (var g = 0; g < this.prjtableData.length; g++) {
          if (this.pageSelect[s].prjId == this.prjtableData[g].prjId) {
            data222.push(this.prjtableData[g]);
          }
        }
      }
      this.toggleSelection(data222);
    },
    fetchData(val) {
      this.page.pageNo = val;
      this.queryPrjtableData();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.page.pageNo = 1;
      this.queryPrjtableData();
    },
    // 翻页勾选
    toggleSelection(rows) {
      this.$nextTick(() => {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      });
    },
    selectall(rows) {
      if (rows.length) {
        var result = [];
        if (this.pageSelect.length) {
          for (var i = 0; i < this.prjtableData.length; i++) {
            var obj = this.prjtableData[i];
            var num = obj.prjId;
            var isExist = false;
            for (var j = 0; j < this.pageSelect.length; j++) {
              var aj = this.pageSelect[j];
              var n = aj.prjId;
              if (n == num) {
                isExist = true;
                break;
              }
            }
            if (!isExist) {
              result.push(obj);
            }
          }
          for (var u = 0; u < result.length; u++) {
            this.pageSelect.push(result[u]);
          }
          // console.log(this.pageSelect,"添加全全全勾选");
        } else {
          for (var i = 0; i < this.prjtableData.length; i++) {
            this.pageSelect.push(this.prjtableData[i]);
          }
        }
      } else {
        for (var t = 0; t < this.prjtableData.length; t++) {
          this.removeByValue(this.pageSelect, "prjId", this.prjtableData[t].prjId);
        }
        // console.log(this.pageSelect,"去掉全全全勾选");
      }
    },
    selectchange(rows, row) {
      const selected = rows.length && rows.indexOf(row) !== -1;
      if (!selected) {
        this.removeByValue(this.pageSelect, "prjId", row.prjId);
        // console.log(this.pageSelect,"去掉单勾选");
      } else {
        this.pageSelect.push(row);
        // console.log(this.pageSelect,"添加单勾选");
      }
    },
    // 复选框不勾选时需要调用的函数
    removeByValue(arr, attr, value) {
      // 数组，属性，属性值
      var index = 0;
      for (var i in arr) {
        if (arr[i][attr] == value) {
          index = i;
          break;
        }
      }
      arr.splice(index, 1);
    },
    synchronization() {
      const templateSpecId = this.nodeData.parent?.data?.templateSpecId || '';
      let type = '';
      if (templateSpecId === 'PM') {
        type = 'prjWithinRole';
      } else if (templateSpecId === 'PRJ_ROLE_MENU_9999') {
        type = 'prjExternalRole';
      } else {
        type = 'major';
      }
      this.$refs.syncMajorRoleDlg.showDlg(type);
    },
    getValue(value) {
      this.catalogueType = value.valueId;
      this.catalogueTypeName = value.valueTitle.split('(')[0];
      this.getDocumentList(this.systemAddOption.roleID, this.systemAddOption.$isOperation);
    },
    async getFinishedProductArea() {
      const { data } = await roleService.getProductAreaTreeNodeList(this.enterpriseId);
      data.forEach(ele => {
        ele.id = ele.folderId;
        ele.cnName = ele.authQuantity > 0 ? ele.folderName + '(' + ele.authQuantity + ')' : ele.folderName;
      });
      this.finishedProductArea = this.getTree(data, "0");
      if (this.catalogueType) {
        this.$refs.selectTree.initHandle();
      }
    },
    getTree(data, parentId) {
      const tree = [];
      let temp;
      for (let i = 0; i < data.length; i++) {
        if (data[i].parentId === parentId) {
          const obj = data[i];
          temp = this.getTree(data, data[i].folderId);
          if (temp.length > 0) {
            obj.childList = temp;
          }
          tree.push(obj);
        }
      }
      return tree;
    },
    iconFn(val) {
      if (this.folderArea !== '3') {
        if (!val.$isOperation) {
          if (val.roleID === 'Sp_001' || val.roleID === 'Sp_002') {
            return this.spec_png;
          } else if (val.roleID === 'Sp_003') {
            return this.pm_png;
          } else if (!val.defaultFlag) {
            return this.customRole_png;
          } else {
            return this.role_png;
          }
        } else {
          return this.major_png;
        }
      } else {
        if (!val.templateSpecId && !val.defaultFlag) {
          return this.customRole_png;
        } else if (!val.templateSpecId && val.defaultFlag) {
          return this.role_png;
        } else {
          return this.major_png;
        }
      }
    },
    async emptyFinishedArea() {
      await roleService.emptyFinishedArea(this.enterpriseId);
      this.$message.success("清空成功");
      await this.getTreeList();
      this.getFinishedProductArea();
    }
  }
};
</script>
<style lang="scss">
.role-auth-aside {
  .el-tree-node__content {
    line-height: 20px;
    padding: 4px;
  }
}
.role-right-table {
  .el-checkbox {
    margin-right: 20px;
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: var(--key-color) !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.role-auth-document {
  height: 100%;
  width: 100%;
  padding: 0;
  position: relative;
  .role-auth-aside {
    position: relative;
    width: 269px;
    height: 100%;
    border-right: 1px solid #ebefff;
    .role-auth_bar {
      padding: var(--middle-space) var(--big-space);
      border-bottom: 1px solid #ebefff;
      .el-icon-synchro {
        cursor: pointer;
        background: url("./img/synchro.png") no-repeat;
        width: 20px;
        height: 30px;
        // margin-top: 6px;
        margin-left: var(--middle-space);
      }
      .el-icon-synchro:before {
        content: "替";
        font-size: 13px;
        visibility: hidden;
      }
    }
    .role-auth-tree {
      overflow: auto;
      position: absolute;
      top: 110px;
      bottom: 10px;
      width: 100%;
    }
  }
  .role-auth-content {
    position: absolute;
    left: 269px;
    right: 0;
    bottom: 0;
    top: 0;
    .role-auth-title {
      display: flex;
      justify-content: space-between;
      padding: var(--middle-space) var(--big-space);
      line-height: 32px;
      span {
        font-size: 16px;
        font-weight: 700;
      }
      .buttons {
        display: flex;
      }
    }
    .role-right-bottom {
      padding: 0 var(--big-space);
      .role-rigth-title {
        color: #58667a;
        font-size: 14px;
        line-height: 18px;
      }
      .role-right-table {
        overflow: auto;
        position: absolute;
        top: 83px;
        bottom: 10px;
        right: 0;
        left: 0;
        padding: 0 var(--big-space);
      }
      .role-right-button {
        float: right;
        margin-top: 10px;
      }
    }
  }
  .empty {
    text-align: center;
    font-size: 36px;
    color: #ddd;
    font-weight: bolder;
    letter-spacing: 5px;
  }
  .textAll {
    width: 150px;
    font-size: 16px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
